<template>
  <div class="loading-container" :class="{ 'fade-out': isLoaded }">
    <div class="coin-container">
      <div class="coin-ring"></div>
      <div class="coin-body">
        <div class="coin-symbol">GCI</div>
      </div>
      <div class="scanning-line"></div>
      <div class="particle-container">
        <div v-for="n in 12" :key="n" class="particle" :style="{
          '--delay': `${n * 0.2}s`,
          '--size': `${4 + Math.random() * 4}px`,
          '--distance': `${35 + Math.random() * 30}px`,
          '--angle': `${n * 30 + Math.random() * 20}deg`
        }"></div>
      </div>
    </div>
    <div class="dots-container">
      <div class="dot" v-for="n in 3" :key="n" :style="{ '--delay': `${0.2 * n}s` }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingAnimation',
  data() {
    return {
      isLoaded: false
    }
  },
  mounted() {
    // 模拟加载完成后淡出
    setTimeout(() => {
      this.isLoaded = true;
      // 通知父组件加载完成
      setTimeout(() => {
        this.$emit('loading-complete');
      }, 800); // 淡出动画时长后触发
    }, 2500); // 2.5秒后开始淡出
  }
}
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #1a1a2e;
  z-index: 9999;
  transition: opacity 0.8s ease-out;
}

.loading-container.fade-out {
  opacity: 0;
  pointer-events: none;
}

.coin-container {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.coin-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid rgba(255, 215, 0, 0.2);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.coin-ring::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #ffd700;
  border-right-color: rgba(255, 215, 0, 0.5);
  animation: spin 1.5s linear infinite;
}

.coin-body {
  position: absolute;
  top: 53.5%;
  left: 53.5%;
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  transform: translate(-50%, -50%);
  background: linear-gradient(145deg, #ffd700, #b8860b);
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 2;
}

.coin-symbol {
  font-size: 22px;
  font-weight: 700;
  color: rgba(26, 26, 46, 0.9);
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
  letter-spacing: -1px;
}

.scanning-line {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: rgba(255, 255, 255, 0.7);
  z-index: 3;
  box-shadow: 0 0 8px #fff, 0 0 15px #ffd700;
  transform-origin: center;
  animation: scan 2s ease-in-out infinite;
}

.particle-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.particle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--size);
  height: var(--size);
  background: #ffd700;
  border-radius: 50%;
  transform: translate(-50%, -50%) rotate(var(--angle)) translateY(var(--distance));
  opacity: 0;
  animation: particleFloat 3s ease-in-out infinite;
  animation-delay: var(--delay);
  filter: blur(1px);
}

.dots-container {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.dot {
  width: 8px;
  height: 8px;
  background: #ffd700;
  border-radius: 50%;
  opacity: 0.4;
  animation: dots 1.5s infinite;
  animation-delay: var(--delay);
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

@keyframes particleFloat {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) rotate(var(--angle)) translateY(0);
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 0.7;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) rotate(var(--angle)) translateY(var(--distance));
  }
}

@keyframes scan {
  0% {
    transform: translateY(-20px) scaleX(0.8);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translateY(20px) scaleX(0.8);
    opacity: 0;
  }
}

@keyframes dots {
  0%, 100% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
  }
}
</style> 